import AmbireLogo from './AmbireLogo'

export default AmbireLogo
